import * as React from 'react'
import { EditAuditBatch } from '@getgreenline/homi-shared'
import { parseAndDownloadCSV, GrPrice } from '../../../../../../utilities/helpers'
import { BlazeButton } from '../../../../../../components/CustomButtons/BlazeButton'
import { AuditModels } from '@getgreenline/audits'

interface Props {
  audit: AuditModels.CreateInventoryAudit
}

const createLineBatchExpectedQty = (batches: EditAuditBatch[]): string => {
  const batchLineArray = batches.map(
    (batch) => `${batch.batchNumber}: ${batch.expectedQuantity} / ${batch.enteredQuantity}`,
  )
  return batchLineArray.join(', ')
}

const exportAsCSV = (audit: AuditModels.CreateInventoryAudit) => {
  const productJSON = audit.products.map((product) => {
    const discrepancyQuantity = (product.enteredQuantity || 0) - (product.expectedQuantity || 0)
    const discrepancyCost = discrepancyQuantity * (product.purchasePrice || 0)

    return {
      id: product.productId,
      sku: product.sku,
      barcode: product.barcode,
      name: product.productName,
      expected: product.expectedQuantity,
      actual: product.enteredQuantity,
      discrepency: parseFloat(discrepancyQuantity.toFixed(4)),
      cost: GrPrice.convertCentToDollar(discrepancyCost),
      notes: product.notes,
      'lot #: qty (expected / actual)': createLineBatchExpectedQty(product.batches),
    }
  })

  parseAndDownloadCSV(`audit-${audit.id}`, productJSON)
}

export const ExportButton = (props: Props) => (
  <BlazeButton
    buttonProps={{
      icon: 'download',
      onClick: () => exportAsCSV(props.audit),
    }}
    titleProps={{
      title: 'Export',
    }}
  />
)
